<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <origen-deuda-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import OrigenDeudaShowData from "./OrigenDeudaShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "OrigenDeudaShow",
        components: {CrudShow, OrigenDeudaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.origenDeuda.showing',
            }
        },
    }
</script>

